"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLogisticCost = void 0;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const big_js_1 = __importDefault(require("big.js"));
const calculate_logistic_order_logistic_cost_1 = require("./calculate-logistic-order-logistic-cost");
const calculate_standard_cost_1 = require("./calculate-logistic-order-logistic-cost/calculate-standard-cost");
const calculateLogisticCost = (logisticOrders) => {
    const standardOrderCost = computeTargetOrderCost(logisticOrders);
    const sumOfBestStandardLogisticOrderTargetOrder = countOrderTarget(logisticOrders, standardOrderCost);
    const pricedLogisticOrders = logisticOrders.map(logisticOrder => {
        return {
            ...logisticOrder,
            shippingCostWithoutDiscount: computeLogisticOrderCost(logisticOrder, standardOrderCost),
            shippingDiscount: computeLogisticOrderDiscount(sumOfBestStandardLogisticOrderTargetOrder, logisticOrder, standardOrderCost)
        };
    });
    const totalLogisticCost = hasOrderTarget(logisticOrders.flatMap(logisticSplit => logisticSplit.lines))
        ? standardOrderCost
        : pricedLogisticOrders
            .reduce((total, pricedLogisticOrder) => total.add(pricedLogisticOrder.shippingCostWithoutDiscount).minus(pricedLogisticOrder.shippingDiscount || 0), (0, big_js_1.default)(0))
            .toString();
    return {
        totalLogisticCost,
        logisticOrders: pricedLogisticOrders
    };
};
exports.calculateLogisticCost = calculateLogisticCost;
function computeLogisticOrderCost(logisticOrder, standardOrderCost) {
    return hasOrderTargetCost(logisticOrder.lines, standardOrderCost)
        ? standardOrderCost
        : (0, calculate_logistic_order_logistic_cost_1.calculateLogisticOrderLogisticCost)(logisticOrder.lines);
}
function computeTargetOrderCost(logisticSplits) {
    const allLines = logisticSplits.flatMap(logisticSplit => logisticSplit.lines);
    const standardTargetOrderLogisticOffers = allLines.filter(logisticOrderLine => isOrderTarget(logisticOrderLine));
    if (standardTargetOrderLogisticOffers.length === 0)
        return '0';
    const groupedLine = {
        linePrice: allLines.reduce((linePrice, line) => linePrice.add(line.linePrice), (0, big_js_1.default)('0')).toString()
    };
    return standardTargetOrderLogisticOffers
        .reduce((shippingCost, logisticOrderLine) => {
        const newShippingCost = (0, big_js_1.default)((0, calculate_standard_cost_1.computeAllStandardCost)([{ ...groupedLine, selectedLogisticOffer: logisticOrderLine.selectedLogisticOffer }]));
        return newShippingCost.toNumber() < shippingCost ? newShippingCost.toNumber() : shippingCost;
    }, Infinity)
        .toString();
}
const isOrderTarget = (logisticOrderLine) => { var _a, _b; return ((_b = (_a = logisticOrderLine.selectedLogisticOffer.feesSchedule) === null || _a === void 0 ? void 0 : _a.standardRule) === null || _b === void 0 ? void 0 : _b.target) === module_logistic_interfaces_1.RuleTarget.Order; };
const hasOrderTarget = (lines) => lines.some(line => isOrderTarget(line));
const hasOrderTargetCost = (lines, standardCost) => hasOrderTarget(lines) && computeTargetOrderCost([{ lines }]) === standardCost;
const countOrderTarget = (logisticSplits, standardCost) => logisticSplits.reduce((sum, logisticSplit) => {
    if (logisticSplit.lines && hasOrderTargetCost(logisticSplit.lines, standardCost))
        return sum + 1;
    return sum;
}, 0);
const computeLogisticOrderDiscount = (sumOfOrder, logisticSplit, totalCost) => {
    return hasOrderTargetCost(logisticSplit.lines, totalCost) || sumOfOrder === 0
        ? computeDiscountForTargetOrderLogisticOrder(sumOfOrder, totalCost)
        : (0, calculate_logistic_order_logistic_cost_1.calculateLogisticOrderLogisticCost)(logisticSplit.lines);
};
const computeDiscountForTargetOrderLogisticOrder = (sumOfOrder, totalCost) => {
    return sumOfOrder <= 1 ? '0' : (0, big_js_1.default)(totalCost).minus((0, big_js_1.default)(totalCost).div(sumOfOrder)).toString();
};
